import React from "react";
import { useHistory } from "react-router-dom";
import { ACTION_DISPLAY_TYPES, CARD_DIRECTIVE_TYPES } from "../../constants/enums";
import { ROUTES as API_ROUTES } from "../../constants/api";
import { ROUTES } from "../../constants/clientRoutes";
import i18n from "../../i18n/config";
import parse from "html-react-parser";
import { useDispatch } from "react-redux";
import { SetIsInAppCard } from "../../actions/card";
import { GetApiData } from "../../api/general";
import { GetUIConfigResponse } from "../../types/api/readyremit";
import { DirectiveTextProps } from "../../types/components";
import useErrorModal from "../../hooks/useErrorModal";
import { trackEvent } from "../../services/eventTracker";
import { EVENTS } from "../../constants/events";

import ActionLink from "./ActionLink";
import CardDetailsLearnMore from "../Dashboard/ModalContent/CardDetailsLearnMore";
import SetupFaceCheckBody from "../MyCard/SetupFaceCheckModal/SetupFaceCheckBody";

const DirectiveText = ({ text, directives, setModalConfig, setModalOpen, setDynamicModalOpen, setDynamicModalConfig }: DirectiveTextProps) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const openErrorModal = useErrorModal();

  // Create a lookup for directive replacements
  const directiveMap = directives.reduce((acc, { directiveType, directiveText }) => {
    acc[`{${directiveType}}`] = (
      <ActionLink
        text={directiveText}
        clickFunc={() => handleClick(directiveType)}
      />
    );
    return acc;
  }, {});

  // Replace directive placeholders with a temporary <span> tag
  const sanitizedMessage = Object.keys(directiveMap).reduce((msg, directive) => {
    const replacement = `<span data-directive="${directive}"></span>`;
    return msg.replace(directive, replacement);
  }, text);

  // Parse the message and replace <span data-directive="..."/> with React components
  const parsed = parse(sanitizedMessage, {
    replace: domNode => {
      if (
        domNode.type === 'tag' &&
        domNode.name === 'span' &&
        domNode.attribs?.['data-directive']
      ) {
        const directiveKey = domNode.attribs['data-directive'];
        return directiveMap[directiveKey] ?? null;
      }
    }
  });

  const handleClick = (directive: string) => {
    switch (directive) {
      case CARD_DIRECTIVE_TYPES.MYCARD:
        history.push(ROUTES.MY_CARD.INDEX);
        break;
      case CARD_DIRECTIVE_TYPES.SUPPORT:
        history.push(ROUTES.SUPPORT_INDEX);
        break;
      case CARD_DIRECTIVE_TYPES.MYCARD_ACTIVATE_CARD_PHYSICAL:
        history.push(ROUTES.MY_CARD.ACTIVATE_REPLACEMENT_CARD);
        break;
      case CARD_DIRECTIVE_TYPES.MYCARD_ACTIVATE_CARD_INAPP:
        history.push(ROUTES.MY_CARD.ACTIVATE_IN_APP_CARD);
        dispatch(SetIsInAppCard(true));
        break;
      case CARD_DIRECTIVE_TYPES.SHOW_DETAILS_LEARN_MORE:
        // Open the modal
        setModalConfig({
          title: i18n.t("PAGES.DASHBOARD.SHOW_CARD_DETAILS_MODAL.TITLE"),
          content: <CardDetailsLearnMore />,
          actions: [
            {
              title: i18n.t("COMMON.CLOSE"),
              onClick: () => setModalOpen(false),
              displayType: ACTION_DISPLAY_TYPES.LINK
            },
            {
              title: i18n.t("PAGES.DASHBOARD.SHOW_CARD_DETAILS_MODAL.BUTTON_TEXT"),
              onClick: () => history.push(ROUTES.MY_CARD.INDEX),
              displayType: ACTION_DISPLAY_TYPES.PRIMARY
            }
          ]
        });
        setModalOpen(true);
        break;
      case CARD_DIRECTIVE_TYPES.MYCARD_SHOW_DETAILS_SETUPFACECHECK:
        setDynamicModalConfig({
          header: <h4 className="gray-1000 bold">{i18n.t("PAGES.MY_CARD.INDEX.SETUP_FACECHECK_MODAL.HEADING")}</h4>,
          content: <SetupFaceCheckBody setOpen={setDynamicModalOpen} />,
          actions: []
        })
        setDynamicModalOpen(true);
        break;
      default:
        break;
    }
  }

  return (
    <>
      {parsed}
    </>
  );
}

export default DirectiveText;